import React from 'react';
import { connect } from 'react-redux';
import { ConferenceInfo, } from 'jitsi/conference/components/web/ConferenceInfo';
import { getConferenceInfo } from 'jitsi/conference/components/functions.any';
import { getParticipantCount } from 'jitsi/base/participants/functions';
import { ConferenceInvitation } from './ConferenceInvitation';
import { ConferenceName } from './ConferenceName';
import { isMobileBrowser } from 'jitsi/base/environment/utils';
class IISightConferenceInfo extends ConferenceInfo {
    render() {
        return (React.createElement("div", { className: `details-container ${isMobileBrowser() ? 'mobile-background' : 'default-background'}`, onFocus: this._onTabIn }, (this.props._participantsCount === 1 || window.APP.isMeetingAuditor) ? (React.createElement(ConferenceInvitation, null)) : (React.createElement(React.Fragment, null,
            this._renderAlwaysVisible(),
            this._renderAutoHide(),
            localStorage.getItem('isVconnect') === 'null' ||
                localStorage.getItem('isVconnect') === 'false' ? (React.createElement(ConferenceName, null)) : null))));
    }
}
function _mapStateToProps(state) {
    return {
        // _visible: isToolboxVisible(state),
        _conferenceInfo: getConferenceInfo(state),
        _participantsCount: getParticipantCount(state),
    };
}
export default connect(_mapStateToProps)(IISightConferenceInfo);
